import './style.css';
import React, { Fragment, useEffect, useState } from 'react';
import { http_request } from '../../../libs/connection';
import { BASE_ROUTE, SESSION_EXPIRED_CODE } from '../../../config';
import { createTimeString, numberWithComma, auth } from '../../../libs/lib';
import { Button, Modal, Toast, ToastContainer } from 'react-bootstrap';
import { BsArrowReturnLeft } from 'react-icons/bs';
import Progress from '../../../components/progress';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Decimal from 'decimal.js';
import { cloneDeep } from 'lodash';

function InvoiceDetail() {
    const navigate = useNavigate();
    const url_params = useParams();
    const location = useLocation();
    const { pathname } = location;
    const { pay_no } = url_params;
    const [is_loading, setLoadingStatus] = useState(false);
    const [invoice, setInvoice] = useState({});
    const [other_items, setOtherItems] = useState([]);
    const [form, setForm] = useState([]);
    const [other_item_invoices, setOtherItemInvoices] = useState([]);
    const [invoice_editor_show, showInvoiceEditor] = useState(false);
    const [success_toast_show, showSuccessToast] = useState(false);
    const [error_toast_show, showErrorToast] = useState(false);
    const [error_message, setErrorMessage] = useState('');


    useEffect(()=>{
        loadOrder();
    }, [pathname, pay_no]);

    function loadOrder(){
        if(!pay_no) return;
        let params = {
            pay_no
        };
        setLoadingStatus(true);
        http_request('/invoice/get', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                let raw_data = res.data.invoices;
                if(raw_data.length === 0){
                    setInvoice({});
                    return;
                }
                let invoice = raw_data[0];
                invoice.detail = raw_data.filter(od=>od.flag !== 'D').map(row=>Object.assign({}, row));
                setInvoice(invoice);
                setOtherItems((res.data.invoice_others || []).filter(item=>item.flag !== 'D'));
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }
        })
    }
    function popInvoiceEditor(){
        setForm(cloneDeep(invoice.detail || []));
        console.log({
            id: invoice.detail,
            other_items
        });
        setOtherItemInvoices(cloneDeep(other_items || []));
        showInvoiceEditor(true);
    }
    function isValidForm(){
        let invoices = [...form, ...other_item_invoices];
        for(let i = 0 ; i < invoices.length ; i++){
            if(!(invoices[i].iv_no)) return false;
        }
        return true;
    }
    function submitForm(){
        let detail = {};
        let other = {};
        form.forEach((row, i)=>{
            detail[row.pay_seq] = { iv_no: row.iv_no };
        })
        other_item_invoices.forEach((row, i)=>{
            other[row.other_seq] = { iv_no: row.iv_no };
        })
        let params = {
            pay_no,
            detail,
            other
        };

        http_request('/invoice/confirm', 'POST', params).then(res=>{
            if(res.success){
                showSuccessToast(true);
                loadOrder();
                showInvoiceEditor(false);
            }else if(res.message === SESSION_EXPIRED_CODE){
                showInvoiceEditor(false);
                navigate(`${BASE_ROUTE}/logout`);
            }else{
                setErrorMessage(res.message || '送出失败');
                showErrorToast(true);
            }
        })
    }
    return (
        <div id="page-invoice-detail" className='page'>
            <Progress show={is_loading} variant="primary" />
            <Modal
                id="page-invoice-detail-dialog"
                show={invoice_editor_show}
                onHide={()=>{ showInvoiceEditor(false); }}
            >
                <Modal.Header closeButton>
                    填写发票
                </Modal.Header>
                <Modal.Body>
                    <div style={{ maxHeight: '70vh' }} className='overflow-auto'>
                        <h4>发票</h4>
                        {
                            (form || []).map((row, r)=><div key={r} className='p-3 invoice mb-2'>
                                <div className='border-bottom pb-2'>{row.ch_no}</div>
                                <div className='mt-2'>
                                    <span className='fw-bold me-2'>请款金额(国币)</span>
                                    <span>{numberWithComma(row.apl_amt1)}</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='fw-bold me-2'>验收单号</span>
                                    <span>{row.ap_no}</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='fw-bold me-2'>凭单单号</span>
                                    <span>{row.ref_no}</span>
                                </div>
                                <div className='mt-2'>
                                    <input
                                        style={{ width: 200 }}
                                        type="text"
                                        placeholder='发票号码'
                                        value={row.iv_no || ''}
                                        onChange={e=>{
                                            let new_form = [...form];
                                            new_form[r] = Object.assign({}, new_form[r]);
                                            new_form[r].iv_no = e.currentTarget.value;
                                            setForm(new_form);
                                        }}
                                    />
                                </div>
                            </div>)
                        }
                        <h4 className='mt-4'>其他款项发票</h4>
                        {
                            (other_item_invoices || []).map((row, r)=><div key={r} className='p-3 other-item-invoice mb-2'>
                                <div className='mt-2'>
                                    <span className='fw-bold me-2'>金额</span>
                                    <span>{numberWithComma(row.amt)}</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='fw-bold me-2'>款项</span>
                                    <span>{row.name}</span>
                                </div>
                                <div className='mt-2'>
                                    <span className='fw-bold me-2'>备註</span>
                                    <span>{row.remark}</span>
                                </div>
                                <div className='mt-2'>
                                    <input
                                        style={{ width: 200 }}
                                        type="text"
                                        placeholder='发票号码'
                                        value={row.iv_no || ''}
                                        onChange={e=>{
                                            let new_list = [...other_item_invoices];
                                            new_list[r] = Object.assign({}, new_list[r]);
                                            new_list[r].iv_no = e.currentTarget.value;
                                            setOtherItemInvoices(new_list);
                                        }}
                                    />
                                </div>
                            </div>)
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer className='d-flex align-items-center justify-content-between'>
                    <Button size='sm' className='px-3' variant='danger' onClick={()=>{ showInvoiceEditor(false); }}>取消</Button>
                    <Button size='sm' className='px-3' variant='primary' disabled={!isValidForm()} onClick={()=>{ submitForm() }}>送出</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer 
                position='middle-bottom'
                style={{ zIndex: 1056 }}
                >
                <Toast 
                    show={success_toast_show} 
                    onClose={()=>{ showSuccessToast(false); }}
                    delay={2000}
                    autohide
                    bg="success"
                    className='text-white'
                >
                    <Toast.Header>
                        <strong className="me-auto">已完成</strong>
                    </Toast.Header>
                    <Toast.Body>已送出发票</Toast.Body>
                </Toast>
            </ToastContainer>
            <ToastContainer
                position='middle-bottom'
                style={{ zIndex: 1056 }}
            >
                <Toast 
                    show={error_toast_show} 
                    onClose={()=>{ showErrorToast(false); }}
                    delay={3000}
                    autohide
                    bg="danger"
                    className='text-white'
                >
                    <Toast.Header>
                        <strong className="me-auto">建立失败</strong>
                    </Toast.Header>
                    <Toast.Body>{error_message}</Toast.Body>
                </Toast>
            </ToastContainer>
            <div className={`bg-white d-block content`}>
                <div className={`d-flex align-items-center justify-content-between py-3 px-2 head-container`}>
                    <span className='text-secondary pe-5 d-flex align-items-center' onClick={()=>{ navigate(-1) }}>
                        <BsArrowReturnLeft size={20} className='pe-2' />
                        <span>返回</span>
                    </span>
                    <span>
                        {
                            auth("company.invoice.confirm") && <Button 
                                size='sm' 
                                variant='success' 
                                className='px-2' 
                                disabled={
                                    Object.keys(invoice).length === 0 || invoice.first_audit == 0 || invoice.second_audit == 0
                                } 
                                onClick={()=>{ popInvoiceEditor(); }}
                            >填写发票号码</Button>
                        }
                    </span>
                </div>
                <div className={`overflow-auto table-container`}>
                    <div className='status-table-container pb-3'>
                        <table className='border border-dark   status-table dtable'>
                            <tbody>
                                <tr>
                                    <td>初审</td>
                                    <td>複审</td>
                                    <td>厂商</td>
                                    <td>审核结果</td>
                                </tr>
                                <tr>
                                    <td>{(invoice.first_audit_user || {}).name || ''}</td>
                                    <td>{(invoice.second_audit_user || {}).name || ''}</td>
                                    <td>{(invoice.confirm_user || {}).name || ''}</td>
                                    <td>{(invoice.result || '').replace(/^\d+\./, '')}　</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <table className={`border border-dark m-auto  dtable`}>
                        <thead>
                            <tr>
                                <th className='text-center' colSpan={4}>
                                    <h1>凹凸精密机械有限公司</h1>
                                    <h3>货款请款单</h3>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={2}>请款单号：{pay_no}</td>
                                <td>请款日期：{createTimeString('y/m/d', invoice.pay_date)}</td>
                                <td>列印日期：{createTimeString('y/m/d')}</td>
                            </tr>
                            <tr>
                                <td>厂商：{invoice.cu_no}</td>
                                <td>{invoice.cu_name}</td>
                                <td colSpan={2}>币别：{invoice.od_name}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className={`border border-top-0 border-dark m-auto  dtable`}>
                        <tbody className='underline text-center'>
                            <tr className='fw-bold text-center'>
                                <td className='border border-dark border-top-0'>採购单号</td>
                                <td className='border border-dark border-top-0'>
                                    <div>验收单号</div>
                                    <div>凭单单号</div>
                                </td>
                                <td className='border border-dark border-top-0'>发票号码</td>
                                <td className='border border-dark border-top-0'>
                                    <div>未税金额</div>
                                    <div>税额</div>
                                </td>
                                <td className='border border-dark border-top-0'>
                                    <div>百分比</div>
                                    <div>汇率</div>
                                </td>
                                <td className='border border-dark border-top-0'>
                                    <div>其他费用</div>
                                    <div>折让金额</div>
                                </td>
                                <td className='border border-dark border-top-0'>
                                    <div>请款金额</div>
                                    <div>(原币)</div>
                                </td>
                                <td className='border border-dark border-top-0'>
                                    <div>请款金额</div>
                                    <div>(国币)</div>
                                </td>
                                <td className='border border-dark border-top-0'>
                                    <div>预付金额</div>
                                    <div>(国币)</div>
                                </td>
                            </tr>
                            {
                                (invoice.detail || []).map((row, r)=><Fragment key={r}>
                                    <tr className="underline">
                                        <td className='tdx-border text-start'>
                                            <div>{row.ch_no}</div>
                                        </td>
                                        <td className='tdx-border text-start'>
                                            <div>{row.ap_no}</div>
                                            <div>{row.ref_no}</div>
                                        </td>
                                        <td className='tdx-border text-start'>
                                            <div>{row.iv_no}</div>
                                        </td>
                                        <td className='tdx-border text-end'>
                                            <div>{numberWithComma(row.ap_amt)}</div>
                                            <div>{numberWithComma(row.ap_tax)}</div>
                                        </td>
                                        <td className='tdx-border text-end'>
                                            <div>{row.pay_rate}%</div>
                                            <div>{row.od_rate}</div>
                                        </td>
                                        <td className='tdx-border text-end'>
                                            <div>{numberWithComma(row.othe_amt)}</div>
                                            <div>{numberWithComma(row.discd_amt)}</div>
                                        </td>
                                        <td className='tdx-border text-end'>
                                            <div>{numberWithComma(row.apl_amt)}</div>
                                        </td>
                                        <td className='tdx-border text-end'>
                                            <div>{numberWithComma(row.apl_amt1)}</div>
                                        </td>
                                        <td className='tdx-border text-end'>
                                            <div>{numberWithComma(row.pre_amt1)}</div>
                                        </td>
                                    </tr>
                                </Fragment>)
                            }
                        </tbody>
                    </table>
                    <table className='`border border-top-0 border-dark m-auto dtable'>
                        <thead>
                            <tr className='underline'>
                                <th className='tdx-border text-center' style={{ width: 100 }}>序号</th>
                                <th className='tdx-border text-center'>应付款事项</th>
                                <th className='tdx-border text-center' style={{ width: 120 }}>金额</th>
                                <th className='tdx-border text-center' colSpan={2}>备註</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (other_items || []).map((row, r)=><tr key={r} className='underline'>
                                    <td className='tdx-border text-center'>{row.other_seq}</td>
                                    <td className='tdx-border'>{row.name}</td>
                                    <td className='tdx-border text-end'>{numberWithComma(Decimal(row.amt || 0))}</td>
                                    <td className='tdx-border' colSpan={2}>{row.remark}</td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                    <table className={`border border-top-0 border-dark m-auto dtable`}>
                        <tbody>
                            <tr className='underline'>
                                <td className='tdx-border '>付款方式</td>
                                <td className='tdx-border ' style={{ width: 200 }} colSpan={4}>{invoice.ch_condi}</td>
                                <td className='tdx-border '>原币合计</td>
                                <td className='tdx-border '>{numberWithComma(invoice.pay_amth)}</td>
                                <td className='tdx-border '>RMB合计</td>
                                <td className='tdx-border '>{numberWithComma(invoice.pay_amth1)}</td>
                            </tr>
                            <tr className='underline'>
                                <td className='tdx-border ' rowSpan={3}>银行资料</td>
                                <td className='tdx-border ' colSpan={4} rowSpan={3}>{invoice.ch_condi}</td>
                                <td className='tdx-border '>原币尾差</td>
                                <td className='tdx-border '>{numberWithComma(invoice.diff_amth)}</td>
                                <td className='tdx-border '>RMB尾差</td>
                                <td className='tdx-border '>{numberWithComma(invoice.diff_amth1)}</td>
                            </tr>
                            <tr className='underline'>
                                <td className='tdx-border'>原币总计</td>
                                <td className='tdx-border'>{numberWithComma(invoice.sum_amth)}</td>
                                <td className='tdx-border'>RMB总计</td>
                                <td className='tdx-border'>{numberWithComma(invoice.sum_amth1)}</td>
                            </tr>
                            <tr className='underline'>
                                <td className='tdx-border'>其他款项总计</td>
                                <td className='tdx-border'>{numberWithComma(other_items.length ? Decimal.sum(...(other_items.map(it=>it.amt))) : 0)}</td>
                                <td className='tdx-border'>总合计</td>
                                <td className='tdx-border'>{numberWithComma(Decimal.sum((invoice.sum_amth1 || 0), ...((other_items||[]).map(it=>it.amt))))}</td>
                            </tr>
                            <tr className='underline'>
                                <td className='tdx-border '>备註</td>
                                <td className='tdx-border ' colSpan={6}>{invoice.pay_memo}</td>
                                <td className='tdx-border '>
                                    <div>领款人</div>
                                    <div>签章</div>
                                </td>
                                <td className='tdx-border '></td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td colSpan={9}>{invoice.ar_relna}</td>
                            </tr>
                            <tr>
                                <td colSpan={9}>　</td>
                            </tr>
                            <tr>
                                <td colSpan={9}>{invoice.ar_asgna}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default InvoiceDetail;
